import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations/translations.json';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: translations,
        fallbackLng: 'en',
        whitelist: ["en", "de", "fr", "es", "it", "sv", "da", "nb", "fi"],
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
